
export default {
  props: {
    group: {
      type: Object,
      required: true,
    },
    partners: {
      type: Array,
      required: true,
    },
  },
  computed: {
    groupPartners () {
      const partners = [];
      if (this.group?.partners?.length) {
        for (const id of this.group.partners) {
          const partner = this.partners.find(partner => partner.id === id);
          if (partner) {
            partners.push(partner);
          }
        }
      }
      return partners;
    },
    title () {
      return this.group.tier_title;
    },
  },
  methods: {
    getPartnerType (partner) {
      return partner.acf?.partner_type;
    },
  },
};
